import React from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { getBids } from 'utils/actions/bids'
import CarrierOptionFormModal from 'apps/marketplace/components/CarrierOptionFormModal'
import { Dialog } from 'components/layout'
import { dialogOptions } from 'constants/dialogs'

export const BookingDialog = React.memo(
  ({ closeDialog, dialogId, dialogOpen, dialogStatusUpdate, shipment }) => {
    const dispatch = useDispatch()
    const { id: shipmentId } = shipment || {}
    const currentDialog = dialogOptions[dialogId]
    if (!currentDialog) return null

    const successHandler = () => {
      dispatch(getBids(shipmentId))
      closeDialog()
    }

    if (dialogId === 'option') {
      return (
        <CarrierOptionFormModal
          shipmentId={shipmentId}
          onClose={closeDialog}
          onSuccess={successHandler}
        />
      )
    }

    return (
      <Dialog
        id={currentDialog.id}
        header={dialogStatusUpdate || currentDialog.header}
        size={currentDialog.size}
        dialogOpen={dialogOpen}
        closeDialog={closeDialog}>
        <currentDialog.component />
      </Dialog>
    )
  }
)

BookingDialog.propTypes = {
  shipment: PropTypes.shape({}),
  dialogOpen: PropTypes.bool.isRequired,
  dialogId: PropTypes.string.isRequired,
  dialogStatusUpdate: PropTypes.string,
  closeDialog: PropTypes.func.isRequired,
}

BookingDialog.defaultProps = {
  shipment: {},
  dialogStatusUpdate: '',
}
